export enum TsePartnerType {
    CUSTOMER = '[0] = Customer',
}



